export enum PaymentProcessorEnum {
    quickBooksPayments = 0,
    stripe = 1,
    noviPay = 2
}
